@use 'Common/Spacing.scss';
@use 'Common/Layout.scss';
@use 'Common/Text.scss';
@use '@lmig/lmds-tokens/dist/scss/core/color';
@use '@lmig/lmds-tokens/dist/scss/core/typography';

body {
  font-size: typography.$lmig-typography-size-rem-default;
  font-weight: typography.$lmig-typography-weight-regular;
}

.standard-font {
  color: color.$lmig-color-text-default;
  font-weight: typography.$lmig-typography-weight-regular;
  font-size: typography.$lmig-typography-h6-default-fontsize-desktop;
}

.force-show-body {
  display: block;
}
.lmig-Tabs-dropdown-select {
  color: black !important;
}
